import React from 'react';
import EmailHeader from './EmailHeader';
import EmailDescription from './EmailDescription';
import EmailClaimButton from './EmailClaimButton';
import EmailOtherButton from './EmailOtherButton';
import EmailThirdButton from './EmailThirdButton';
import { ConfigClientType } from '../types/ConfigClientType';
import { VisibilityType } from '../types/VisibilityType';
import { isSwedish, isDanish } from '../../constants/languages';

type EmailMenuProps = {
    iimclient: ConfigClientType;
    visibility: VisibilityType;
};

const EmailMenu = ({ iimclient, visibility }: EmailMenuProps) => {
  const { lang, novertikal, texts, segment, nocom } = iimclient;

  const hideOtherButton = isDanish(iimclient) || (isSwedish(iimclient) && !segment) || novertikal;
  const hideThirdButton = !texts['email-third-button'];
  
  const OtherButtonLinkUrl = nocom ? 'https://www.if.no/bedrift/kundeservice/skriv-til-oss/andre-henvendelser' : ''
  const EmailClaimLinkUrl = nocom ? 'https://www.if.no/bedrift/meld-skade' : ''

  const isRendered = visibility.activeMenu === 'email';

  return isRendered && (
    <div className="openbox emailbox">
      <div className="content">
        <EmailHeader iimclient={iimclient} />
        <EmailDescription iimclient={iimclient} />
        <EmailClaimButton iimclient={iimclient} linkUrl={EmailClaimLinkUrl} />
        {!hideOtherButton && (
          <EmailOtherButton iimclient={iimclient} linkUrl={OtherButtonLinkUrl} />
        )}
        {!hideThirdButton && (
          <EmailThirdButton iimclient={iimclient} />
        )}
      </div>
    </div>
  );
};

export default EmailMenu;
